import React, { useEffect, useState } from 'react';
import { FaBookReader, FaSearch, FaChalkboardTeacher, FaRobot, FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaSignInAlt, FaNewspaper, FaFileAlt, FaBookOpen, FaPenNib, FaLayerGroup, FaTabletAlt, FaTable, FaFileSignature } from 'react-icons/fa';
import CountUp from 'react-countup';
import Lottie from 'lottie-react';
import atomsAnimation2 from '../assets/Animation_1736003462054.json';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box
} from '@mui/material';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function Homepage() {
  const [scrolled, setScrolled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [openTrialModal, setOpenTrialModal] = useState(false);
  const [trialForm, setTrialForm] = useState({
    name: '',
    email: '',
    mobile: '',
    institution: ''
  });
  const [trialStatus, setTrialStatus] = useState('');
  const [subjects, setSubjects] = useState([]);


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  useEffect(() => {
    axios.get('https://backend.scholarkart.in/api/subjects/on-sale')
      .then(response => {
        setSubjects(response.data);
      })
      .catch(error => {
        console.error('Error fetching subjects:', error);
      });
  }, []);

  const stats = [
    { icon: <FaNewspaper />, value: 200200000, label: "Journal Articles" },
    { icon: <FaLayerGroup />, value: 22900000, label: "Book Chapters" },
    { icon: <FaTable />, value: 7684000, label: "Dataset" },
    { icon: <FaPenNib />, value: 6729000, label: "Preprint" },
    { icon: <FaFileAlt />, value: 6176000, label: "Dissertations" },
    { icon: <FaBookOpen />, value: 5702000, label: "Books" },
    { icon: <FaTabletAlt />, value: 466000, label: "OA eBooks" },
    { icon: <FaFileSignature />, value: 200000, label: "eJournals" },
  ];


  const handleTrialSubmit = async () => {
    const { name, email, mobile, institution } = trialForm;
  
    if (!name || !email || !mobile || !institution) {
      setTrialStatus('All fields are required.');
      return;
    }
  
    try {
      await axios.post('https://backend.scholarkart.in/api/trial-request', {
        name, email, mobile, institution
      });
  
      setTrialStatus('Request sent successfully!');
      setTimeout(() => {
        setOpenTrialModal(false);
        setTrialForm({ name: '', email: '', mobile: '', institution: '' });
        setTrialStatus('');
      }, 2000);
    } catch (err) {
      setTrialStatus('Failed to send request.');
      console.error(err);
    }
  };

  
  return (
    <div className="bg-white text-gray-800 dark:bg-gray-900 dark:text-white">
      {/* Header */}
      <header className={`fixed top-0 z-50 w-full transition-all duration-300 ${scrolled ? 'bg-gradient-to-r from-[#023a87] to-[#012f6e]' : 'bg-white dark:bg-gray-900'}`}>
        <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
          <a href="/" className="block">
          <div className="flex items-center gap-2">
            <img src={scrolled ? "/eBrary.png" : "/eBrary_Logo.png"} alt="Logo" className="h-12 w-auto transition duration-300" />
          </div>
          </a>
          <nav className="hidden md:flex gap-6 font-medium">
            <a href="#features" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>Key Features</a>
            <a href="#institutions" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>For Institutions</a>
            <a href="#subjects" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>Popular Courses</a>
            <a href="#stats" className={`font-bold hover:text-[#ff7a00] transition duration-200 ${scrolled ? 'text-white' : 'text-[#023a87]'}`}>Statistics</a>
          </nav>
          <div>
          <Link to="/LoginPage">
            <button className={`px-6 py-2 rounded-full flex items-center gap-x-2 transition duration-200 ${scrolled ? 'bg-white text-blue-600 hover:bg-gray-100' : 'bg-[#ff7a00] text-white hover:bg-orange-600'}`}>
              <FaSignInAlt />
              <span>Login</span>
            </button>
          </Link>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="min-h-screen pt-[70px] bg-gradient-to-r from-[#023a87] to-[#012f6e] text-white">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 items-center gap-10">
          <div>
          <h1 className="text-4xl md:text-5xl font-extrabold leading-tight mb-8 pt-10 md:pt-0 text-white/90">Empower Learning.<br />Explore Limitlessly.</h1>
            <p className="text-lg mb-4 text-amber-400">Harnessing the power of Artificial Intelligence (AI), eBrary.guru platform is set to transform the eLearning experience with groundbreaking innovations.</p>
            <div className="flex gap-4">
              <Link to="/SignupPage">
                <button className={`px-6 py-3 rounded-full flex items-center gap-x-2 transition duration-200 ${scrolled ? 'bg-white text-blue-600 hover:bg-gray-100' : 'bg-[#ff7a00] text-white hover:bg-orange-600'}`}>
                  <FaSignInAlt />
                  <span>Create Account</span>
                </button>
              </Link>
              <button className="border border-white text-white px-6 py-3 rounded-full cursor-default">It's FREE</button>
            </div>
          </div>
          <div>
            {/* Lottie Animation */}
            <Box
              sx={{
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1,
                pointerEvents: 'none',
                overflow: 'hidden',
              }}
            >
              <Lottie
                animationData={atomsAnimation2}
                loop={true}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </div>
        </div>
      </section>


      <section id="features" className="py-20 bg-white dark:bg-gray-900">
        <div className="max-w-7xl mx-auto px-4">

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <FaRobot className="text-3xl text-white" />,
                title: "AI-powered Learning",
                desc: "Instant answers from textbooks with our intelligent GPT-powered assistant.",
              },
              {
                icon: <FaSearch className="text-3xl text-white" />,
                title: "Smart Search",
                desc: "Semantic search across eBooks, eJournals, videos, theses, and more.",
              },
              {
                icon: <FaBookOpen className="text-3xl text-white" />,
                title: "Chapter-wise Reading",
                desc: "Split eBooks into chapters for focused and quick access to topics.",
              },
              {
                icon: <FaChalkboardTeacher className="text-3xl text-white" />,
                title: "Course-wise Library",
                desc: "Auto-filtered resources based on your course, semester, and subjects.",
              },
            ].map((feature, idx) => (
              <div
                key={idx}
                className="bg-gradient-to-br from-[#023a87] to-[#03459c] text-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 relative overflow-hidden"
              >
                <div className="bg-amber-500 rounded-full w-12 h-12 flex items-center justify-center mb-4 shadow-md">
                  {feature.icon}
                </div>
                <h4 className="text-lg font-bold mb-2 text-white">{feature.title}</h4>
                <p className="text-sm text-gray-200">{feature.desc}</p>
                <div className="absolute inset-0 rounded-2xl hover:ring-2 hover:ring-amber-400 transition-all duration-300 pointer-events-none" />
              </div>
            ))}
          </div>
        </div>
      </section>




    <section id="subjects" className="py-10 bg-gradient-to-r from-[#f5f7fa] to-[#f5f7fa] dark:bg-gray-900 relative">
      
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-bold text-center text-[#012f6e] dark:text-white mb-12">
          Popular eLearning Subjects
        </h2>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
          {subjects.map((subject, idx) => (
            <div
              key={idx}
              className="bg-white dark:bg-gray-700 rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition duration-300"
            >
              <img
                src={subject.coverImage }
                alt={subject.subjectName}
                className="w-full h-30 object-cover"
              />
              <div className="p-6">
                <span className="inline-block bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full mb-2">
                  ₹{subject.price} one-time
                </span>
                {subject.courseIds && subject.courseIds.length > 0 && (
                  <div className="text-sm text-gray-500 dark:text-gray-400">
                    {subject.courseIds.map((course, index) => (
                      <div key={index}>
                        {course.courseName}
                      </div>
                    ))}
                  </div>
                )}
                <h4 className="text-xl font-bold text-[#012f6e] dark:text-white mb-1">
                  {subject.subjectName}
                </h4>
                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                  {subject.subjectOutcome?.slice(0, 100)}...
                </p>
                {subject.courseIds && subject.courseIds.length > 0 && (
                  <div className="text-sm text-gray-500 dark:text-gray-400">
                    {subject.courseIds.map((course, index) => (
                      <div key={index}>
                        {course.affiliation}
                      </div>
                    ))}
                  </div>
                )}
                <Link to={`/subjects_details/${subject._id}`} className="block w-full">
                  <button className="w-full bg-[#ff7a00] text-white py-2 rounded-full hover:bg-orange-600 transition">
                    Explore Module
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>




      {/* Institutions Section */}
      <section id="institutions" className="py-10 bg-gradient-to-r from-[#f5f7fa] to-[#f5f7fa] dark:bg-gray-900 relative">
        <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
          
          {/* Left: Textual Content */}
          <div className="bg-white rounded-xl shadow-xl p-6 dark:bg-gray-800">
            <h2 className="text-3xl font-bold mb-4 text-blue-900 dark:text-white">
              For Institutions <span className="text-amber-500">[Libraries]</span>
            </h2>
            <p className="mb-6 text-gray-700 dark:text-gray-300">
              Empower your faculty and students with seamless access to an AI-driven digital library solution designed to revolutionize academic research and learning.
            </p>
            <ul className="space-y-4 text-gray-800 dark:text-white">
              <li><span className="text-[#023a87] font-semibold">🔹 25 Crore Publications</span> - Access Universal Knowledge Database.</li>
              <li><span className="text-[#023a87] font-semibold">🔹 One Lakh eBrary eBooks</span> - Diverse, ready-to-access collections.</li>
              <li><span className="text-[#023a87] font-semibold">🔹 Library Book Configuration</span> - Upload Library books, Lecture notes etc.</li>
              <li><span className="text-[#023a87] font-semibold">🔹 Course & Subject Integration</span> - Link textbooks to Subjects and Course.</li>
            </ul>
            <p className="mt-6 font-bold text-blue-900 dark:text-white">
              Join the future of digital libraries and enhance knowledge accessibility like never before.
            </p>
            <button
              className="mt-6 bg-[#ff7a00] text-white px-6 py-2 rounded-full hover:bg-orange-600"
              onClick={() => setOpenTrialModal(true)}
            >
              Request for Trial
            </button>
            <Dialog open={openTrialModal} onClose={() => setOpenTrialModal(false)}>
              <DialogTitle>📚 Request for Trial Access</DialogTitle>
              <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 400 }}>
                <TextField
                  label="Name"
                  value={trialForm.name}
                  onChange={(e) => setTrialForm({ ...trialForm, name: e.target.value })}
                  fullWidth
                />
                <TextField
                  label="Email ID"
                  value={trialForm.email}
                  onChange={(e) => setTrialForm({ ...trialForm, email: e.target.value })}
                  fullWidth
                />
                <TextField
                  label="Mobile"
                  value={trialForm.mobile}
                  onChange={(e) => setTrialForm({ ...trialForm, mobile: e.target.value })}
                  fullWidth
                />
                <TextField
                  label="Institution Name"
                  value={trialForm.institution}
                  onChange={(e) => setTrialForm({ ...trialForm, institution: e.target.value })}
                  fullWidth
                />
                {trialStatus && (
                  <p className="text-green-600 text-sm">{trialStatus}</p>
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setOpenTrialModal(false)}>Cancel</Button>
                <Button variant="contained" onClick={handleTrialSubmit}>Send</Button>
              </DialogActions>
            </Dialog>

          </div>

          {/* Right: Image */}
          <div className="w-full h-auto">
            <img
              src="/dl1.png"
              alt="AI Libraries Infographic with Books and Charts"
              className="w-full h-auto rounded-2xl shadow-lg object-contain"
            />
          </div>
        </div>
      </section>

      

      {/* Stats Section */}
      <section id="stats" className="bg-[#023a87] py-16">
        <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, idx) => (
              <div
                key={idx}
                className="w-full sm:w-52 h-40 rounded-3xl px-4 flex flex-col items-center justify-center text-white
                  bg-gradient-to-br from-[#03459c] to-[#0251b3]
                  shadow-[0_0_20px_rgba(2,58,135,0.6)]
                  hover:shadow-[0_0_30px_rgba(255,122,0,0.8)]
                  hover:ring-4 hover:ring-amber-400
                  transition duration-300 ease-in-out"
              >
                <div className="text-3xl mb-1 transition group-hover:scale-110">
                  {stat.icon}
                </div>
                <div className="text-xl font-bold">
                  <CountUp end={stat.value} duration={2.5} separator="," />+
                </div>
                <p className="text-sm mt-1 text-center">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* Footer */}
      <footer className="bg-gradient-to-r from-[#012f6e] to-[#023a87] text-white py-10 backdrop-blur-sm shadow-inner">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr_1fr] gap-10">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img src="/eBrary.png" alt="eBrary Logo" className="h-12 w-auto" />
            </div>
            <p className="text-sm text-gray-300">
            eBrary.guru is an innovative Digital Library and eLearning platform designed to 
          support students with global eBrary, featuring the largest collection of eBooks and 
          eJournals, as well as a campus eBrary with textbooks and reference 
          books for all subjects. An AI-powered chatbot enhances the eLearning 
          experience by answering student's any question from the textbooks.
            </p>
          </div>

          {/* eBrary Modules with hover animation */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">eBrary Modules</h4>
            <ul className="text-sm space-y-2 text-gray-300">
              <li>
                <a
                  href="/mycourse"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  My Courses
                </a>
              </li>
              <li>
                <a
                  href="/mylibrary"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  My Library
                </a>
              </li>
              <li>
                <a
                  href="/ebrarycollection"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  eBrary Collection
                </a>
              </li>
              <li>
                <a
                  href="/ejournals"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  Research Journals
                </a>
              </li>
              <li>
                <a
                  href="/journal_articles"
                  className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                >
                  Research Articles
                </a>
              </li>
            </ul>
          </div>


          {/* Quick Links with hover animation */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Quick Links</h4>
            <ul className="text-sm space-y-2 text-gray-300">
              {["Courses", "Features", "Institutions", "Stats"].map((item) => (
                <li key={item}>
                  <a
                    href={`#${item.toLowerCase()}`}
                    className="relative inline-block after:block after:h-[2px] after:bg-amber-400 after:scale-x-0 after:transition-transform after:origin-left hover:after:scale-x-100"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>





          {/* Contact Info + Social Icons */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-amber-400">Connect</h4>
            <p className="text-sm text-gray-300 mb-1">
              Email: <a href="mailto:ebraryguru@gmail.com" className="hover:text-white">info@ebrary.guru</a>
            </p>
            <p className="text-sm text-gray-300 mb-4">
              WhatsApp:{" "}
              <a
                href="https://wa.me/919886688939"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white underline"
              >
                +91-9886688939
              </a>
            </p>

            <div className="flex gap-4">
              <a href="#" className="text-gray-300 hover:text-white transition"><FaFacebookF /></a>
              <a href="#" className="text-gray-300 hover:text-white transition"><FaTwitter /></a>
              <a href="#" className="text-gray-300 hover:text-white transition"><FaLinkedinIn /></a>
              <a href="#" className="text-gray-300 hover:text-white transition"><FaYoutube /></a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-4 pt-6 text-center text-sm text-gray-400 border-t border-white/10">
          &copy; {new Date().getFullYear()} eBrary.guru. All rights reserved.
        </div>
      </footer>

    </div>
  );
}
